var _createClass = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/classCallCheck.js");

/*
  This is a top-level Use Cases library. This library loads all other
  use case libraries, and bundles them into a single object.
*/
// Local libraries
var ThisNodeUseCases = require('./this-node-use-cases.js');

var RelayUseCases = require('./relay-use-cases');

var PubsubUseCases = require('./pubsub-use-cases');

var PeerUseCases = require('./peer-use-cases');

var UseCases = /*#__PURE__*/function () {
  "use strict";

  function UseCases() {
    var localConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, UseCases);

    this.adapters = localConfig.adapters;

    if (!this.adapters) {
      throw new Error('Must inject instance of adapters when instantiating Use Cases library.');
    }

    this.controllers = localConfig.controllers;

    if (!this.controllers) {
      throw new Error('Must inject instance of controllers when instantiating Use Cases library.');
    } // Encapsulate dependencies


    this.thisNode = new ThisNodeUseCases(localConfig); // Other use-cases depend on the thisNode use case.

    localConfig.thisNodeUseCases = this.thisNode;
    this.relays = new RelayUseCases(localConfig);
    this.pubsub = new PubsubUseCases(localConfig);
    this.peer = new PeerUseCases(localConfig); // Pass the instances of the other use cases to the ThisNode Use Cases.

    this.thisNode.updateUseCases(this);
  }

  return _createClass(UseCases);
}();

module.exports = UseCases;